import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiDeleteBin5Line } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import Coin from "../assets/coin.png";
import More from "../assets/more.png";
import axios from "axios";

// import { Circles } from "react-loader-spinner";

import { BaseUrl } from "../App";
import { FadeLoader } from "react-spinners";
const Service = () => {
  const navigate = useNavigate();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [serviceStates, setServiceStates] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltipdata, setShowTooltipdata] = useState(false);

  const [bookedServices, setBookedServices] = useState([]); 
  // Fetch data from backend when the page loads
  // useEffect(() => {
  //   const fetchServices = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await axios.post(
  //         `${BaseUrl}/backend/api/services.php`,
  //         {
  //           action: "get_all_services", // Action to get all services
  //           api_key: "1", // Send API key (adjust as needed)
  //         }
  //       );
  //       console.log(response);
  //       // Handle the response
  //       if (response.data.status === "true") {
  //         // Map the response to include a boolean 'enabled' property
  //         const formattedServices = response.data.response.map((service) => ({
  //           ...service,
  //           enabled: service.status === "E", // Set 'enabled' based on 'status'
  //         }));
  //         setServiceStates(formattedServices); // Update the state with the fetched services
  //       } else {
  //         setError(response.data.response || "Failed to load services.");
  //       }
  //     } catch (error) {
  //       setError("An error occurred while fetching services.");
  //       console.error("API error:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchServices(); // Call fetchServices on component mount
  // }, []);
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch all services
        const servicesResponse = await axios.post(
          `${BaseUrl}/backend/api/services.php`,
          {
            action: "get_all_services",
            api_key: "1",
          }
        );

        // Fetch all bookings
        const bookingsResponse = await axios.post(
          `${BaseUrl}/backend/api/book_appointment.php`,
          {
            action: "getallbookings",
            api_key: "1",
            start_date: "2025-01-01", // Adjust these dates as needed
            end_date: "2025-12-31",
          }
        );

        if (servicesResponse.data.status === "true") {
          const formattedServices = servicesResponse.data.response.map(
            (service) => ({
              ...service,
              enabled: service.status === "E",
            })
          );
          setServiceStates(formattedServices);
        }

        if (bookingsResponse.data.status === "true") {
          // Store booked service IDs
          const bookedServiceIds = bookingsResponse.data.response.map(
            (booking) => booking.service_id
          );
          setBookedServices(bookedServiceIds);
        }
      } catch (error) {
        setError("An error occurred while fetching data.");
        console.error("API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [services, setservices] = useState({
    title: "",
    description: "",
    color: "#808080",
    image: "",
  });

  const [editServiceId, setEditServiceId] = useState(null);
  const [editServiceData, setEditServiceData] = useState(null);
  const toggleService = async (id) => {
    setLoading(true); // Start loading state
    setError(""); // Reset errors

    // Toggle the service's 'enabled' state
    const updatedServiceState = serviceStates.map((service) =>
      service.id === id
        ? { ...service, enabled: !service.enabled } // Toggle the 'enabled' state
        : service
    );

    setServiceStates(updatedServiceState); // Update the UI state immediately

    const service = updatedServiceState.find((service) => service.id === id);
    const newStatus = service.enabled ? "E" : "D"; // E for enabled, D for disabled

    try {
      // Make an API request to update the service status
      const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
        action: "change_status", // Action to change the status
        api_key: 1, // API key
        service_id: id, // Service ID to update
        status: newStatus, // New status (E for enabled, D for disabled)
      });

      // Log the response for debugging
      console.log("Response Data:", response);

      if (response.data.status === "true") {
        setSuccessMessage("Service Change Statuts successfully!");
        // If status update is successful, reset error and success message
        alert("Change Status Successfully", response);
        setError("");
      } else {
        // If the status update failed, show the error message and revert the UI state
        setError(response.data.response || "Failed to change status.");
        setServiceStates(serviceStates); // Revert state if failed
      }
    } catch (error) {
      setError("An error occurred while changing status.");
      console.error("API error:", error);
      setServiceStates(serviceStates); // Revert state if error occurs
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // Ensure all required fields are provided
    if (!services.title || !services.description) {
      setError("Please fill in all required fields.");
      return;
    }

    setLoading(true); // Start loading state
    setError(""); // Reset previous errors

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
        action: "add_service", // Action parameter to indicate the action
        api_key: 1, // Send the API key to the backend
        title: services.title, // Service name
        color: services.color, // Service color
        description: services.description, // Service description
        image: services.image, // Uncomment if image is needed
        status: "D", // Service status initially set to disabled
      });

      // Log the response for debugging
      console.log("Response Data:", response);

      // Check if the response status is "true"
      if (response.data.status === "true") {
        setSuccessMessage("Service Add successfully!");
        alert("service added Successfully", response);
        setError(""); // Clear any previous errorse
        setServiceStates((prevState) => [
          ...prevState,
          {
            id: serviceStates.length - 1,
            ...services,
            enabled: false,
          },
        ]);
        setservices({
          title: "",
          description: "",
          color: "#808080",
          image: "",
        }); // Reset form
        setIsSliderOpen(false); // Close slider

        // Hide success message after 3 seconds
        setTimeout(() => setSuccessMessage(false), 3000);
      } else {
        setError(
          response.data.response || "Failed to add service. Please try again."
        );
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
      console.error("API error:", error);
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };
  const handleEdit = (id) => {
    if (editServiceId === id) {
      setEditServiceId(null);
      setEditServiceData(null);
    } else {
      const serviceToEdit = serviceStates.find((service) => service.id === id);
      setEditServiceId(id);
      setEditServiceData({ ...serviceToEdit });
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    if (!editServiceData.title || !editServiceData.description) {
      setError("Please fill in all required fields.");
      return;
    }

    setLoading(true); // Start loading state
    setError(""); // Reset previous errors

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
        action: "update_service",
        api_key: 1,
        service_id: editServiceId, // Make sure this is passed
        title: editServiceData.title,
        color: editServiceData.color,
        description: editServiceData.description,
        // image: editServiceData.image || "",
      });

      // Log the response for debugging
      console.log("Response Data:", response.data);

      if (response.data.status === "true") {
        setError(""); // Clear any previous errors
        setSuccessMessage("Service Updated successfully!"); // Show success message

        // Update the service list with the updated data
        setServiceStates((prevState) =>
          prevState.map((service) =>
            service.id === editServiceId
              ? { ...response.data.response }
              : service
          )
        );

        // Reset edit state
        setEditServiceId(null);
        setEditServiceData(null);
      } else {
        setError(response.data.response || "Failed to update service.");
      }
    } catch (error) {
      setError("An error occurred while updating the service.");
      console.error("API error:", error);
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  const handleReset = () => {
    const originalService = serviceStates.find(
      (service) => service.id === editServiceId
    );
    setEditServiceData({ ...originalService });
  };

  const handleDelete = async () => {
    setLoading(true); // Start loading state
    setError(""); // Reset previous errors

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
        action: "delete_service",
        api_key: 1, // Replace with actual API key
        service_id: deleteServiceId, // The service to delete
      });

      // Log the response for debugging
      console.log("Response Data:", response.data);

      if (response.data.status === "true") {
        setSuccessMessage("Service deleted successfully!"); // Show success message

        // Remove the deleted service from the state
        setServiceStates((prevState) =>
          prevState.filter((service) => service.id !== deleteServiceId)
        );

        // Reset delete modal and service id
        setDeleteServiceId(null);
        setIsDeleteModalVisible(false);
      } else {
        setError(response.data.response || "Failed to delete service.");
      }
    } catch (error) {
      setError("An error occurred while deleting the service.");
      console.error("API error:", error);
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  const handlePricingClick = (serviceId) => {
    console.log("Selected Service ID:", serviceId); // Check if ID is passed
    sessionStorage.setItem("selectedServiceId", serviceId);
    const selectedService = serviceStates.find(
      (service) => service.id === serviceId
    );

    navigate("pricing", {
      state: { serviceName: selectedService.title, serviceId },
    });
  };

  const handleAddClick = (serviceId) => {
    console.log("Selected   Service ID:", serviceId); // Check if ID is passed
    sessionStorage.setItem("selectedServiceId", serviceId);
    const selectedService = serviceStates.find(
      (service) => service.id === serviceId
    );
    if (selectedService) {
      navigate("addons", {
        state: { serviceName: selectedService.title, serviceId },
      });
    }
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
        <div className="container mx-auto px-4 md:px-6 lg:px-8  xl:px-24 py-6 ">
             {successMessage && (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
                <span className="block sm:inline">{successMessage}</span>
              </div>
            )}

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
                <span className="block sm:inline">{error}</span>
              </div>
            )}

          <div className="flex flex-col md:flex-row justify-between items-center mb-6">
            <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-0 text-center md:text-left">
              All Services
            </h1>
            <button
              onClick={() => setIsSliderOpen(true)}
              className="w-full md:w-auto px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition"
            >
              + Add Cleaning Service
            </button>
          </div>
          <div className="space-y-4">
            {serviceStates.map((service) => (
              <div
                key={service.id}
                className="flex flex-col p-4 border border-gray-300 rounded-lg shadow-sm space-y-4"
              >
                <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
                  <div className="flex items-center space-x-3 w-full">
                    <div
                      className="w-6 h-6 rounded-md flex-shrink-0"
                      style={{ backgroundColor: service.color }}
                      title={`Color for ${service.name}`}
                    ></div>
                    <span className="text-lg md:text-xl font-medium truncate flex-grow">
                      {service.title}
                    </span>
                  </div>
                  <div className="flex flex-wrap justify-center md:justify-end gap-3 w-full">
                    <img
                      src={Coin}
                      alt="Pricing"
                      onClick={() => handlePricingClick(service.id)}
                      className="w-6 h-6 m-1 cursor-pointer"
                      onMouseEnter={() => setShowTooltipdata(true)} // Show on hover
                      onMouseLeave={() => setShowTooltipdata(false)} // Hide when not hovered
                    />

                    {showTooltipdata && (
                      <div className="absolute top-[130px] left-1/2 transform -translate-x-1/2 bg-black text-white text-sm px-2 py-1 rounded-md shadow-md">
                        Pricing
                      </div>
                    )}

                    <img
                      src={More}
                      alt="Add"
                      onClick={() => handleAddClick(service.id)}
                      onMouseEnter={() => setShowTooltip(true)} // Show on hover
                      onMouseLeave={() => setShowTooltip(false)} // Hide when not hovered
                      className="w-6 h-6 m-1 cursor-pointer"
                    />

                    {showTooltip && (
                      <div className="absolute top-[130px] left-1/2 transform -translate-x-1/2 bg-black text-white text-sm px-2 py-1 rounded-md shadow-md">
                        Addons
                      </div>
                    )}

                    <button
                      onClick={() => toggleService(service.id)}
                      className={`relative w-12 h-6 rounded-full transition-all duration-300 flex items-center justify-center text-sm ${
                        service.enabled
                          ? "bg-green-500 text-white"
                          : "bg-red-500 text-white"
                      }`}
                    >
                      <div
                        className={`w-6 h-6 bg-white rounded-full absolute top transition-all ${
                          service.enabled ? "right-0.5" : "left-0.5"
                        }`}
                      />
                    </button>
                    <div className="flex space-x-2">
                      {bookedServices.includes(service.id) ? (
                        <button
                          className="px-2 py-1 bg-red-500 text-white rounded-md text-sm relative group"
                        >
                          Booked
                          <span className="absolute hidden group-hover:block bg-black text-white text-xs rounded py-1 px-2 -top-8 left-1/2 transform -translate-x-1/2">
                            This service is booked
                          </span>
                        </button>
                      ) : (
                        <RiDeleteBin5Line
                          onClick={() => {
                            setDeleteServiceId(service.id);
                            setIsDeleteModalVisible(true);
                          }}
                          className="w-8 h-8 cursor-pointer text-red-500 hover:opacity-80"
                        />
                      )}
                      <BiSolidEdit
                        onClick={() => handleEdit(service.id)}
                        className="w-8 h-8 cursor-pointer text-blue-500 hover:opacity-80"
                      />
                    </div>
                  </div>
                </div>
                {editServiceId === service.id && (
                  <div className="border-t border-gray-300 pt-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium mb-2">
                          Color
                        </label>
                        <input
                          type="color"
                          value={editServiceData.color}
                          onChange={(e) =>
                            setEditServiceData({
                              ...editServiceData,
                              color: e.target.value,
                            })
                          }
                          className="w-full h-12 border rounded-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-2">
                          Service Name
                        </label>
                        <input
                          type="text"
                          value={editServiceData.title}
                          onChange={(e) =>
                            setEditServiceData({
                              ...editServiceData,
                              title: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border rounded-md"
                        />
                      </div>
                      <div className="md:col-span-2">
                        <label className="block text-sm font-medium mb-2">
                          Description
                        </label>
                        <textarea
                          value={editServiceData.description}
                          onChange={(e) =>
                            setEditServiceData({
                              ...editServiceData,
                              description: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border rounded-md"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-2">
                          Image
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const validTypes = [
                                "image/jpeg",
                                "image/png",
                                "image/gif",
                              ];
                              if (validTypes.includes(file.type)) {
                                setEditServiceData({
                                  ...editServiceData,
                                  image: URL.createObjectURL(file),
                                });
                              } else {
                                alert(
                                  "Invalid file type. Please upload JPG, PNG, or GIF."
                                );
                              }
                            }
                          }}
                          className="w-full"
                        />
                      </div>
                    </div>
                    <div className="flex space-x-2 mt-4">
                      <button
                        onClick={handleUpdate}
                        className="px-4 py-2 bg-green-500 text-white rounded-md"
                      >
                        Update
                      </button>
                      <button
                        onClick={handleReset}
                        className="px-4 py-2 bg-gray-500 text-white rounded-md"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {isSliderOpen && (
            <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-75 flex items-center justify-center p-6">
              <div className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-auto">
                <div className="p-4 sm:p-6">
                  <h2 className="text-xl sm:text-2xl font-bold mb-4">
                    Add New Service
                  </h2>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium mb-1 sm:mb-2">
                        Service Name
                      </label>
                      <input
                        type="text"
                        value={services.title}
                        onChange={(e) =>
                          setservices({ ...services, title: e.target.value })
                        }
                        className="w-full px-3 sm:px-4 py-2 border rounded-md text-sm sm:text-base"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1 sm:mb-2">
                        Color
                      </label>
                      <input
                        type="color"
                        value={services.color}
                        onChange={(e) =>
                          setservices({ ...services, color: e.target.value })
                        }
                        className="w-full h-10 sm:h-12 border rounded-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1 sm:mb-2">
                        Description
                      </label>
                      <textarea
                        value={services.description}
                        onChange={(e) =>
                          setservices({
                            ...services,
                            description: e.target.value,
                          })
                        }
                        className="w-full px-3 sm:px-4 py-2 border rounded-md text-sm sm:text-base min-h-[100px]"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1 sm:mb-2">
                        Image
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const validTypes = [
                              "image/jpeg",
                              "image/png",
                              "image/gif",
                            ];
                            if (validTypes.includes(file.type)) {
                              setservices({
                                ...services,
                                image: URL.createObjectURL(file),
                              });
                            } else {
                              alert(
                                "Invalid file type. Please upload JPG, PNG, or GIF."
                              );
                            }
                          }
                        }}
                        className="w-full text-sm sm:text-base"
                      />
                    </div>
                  </div>
                  <div className="flex justify-end space-x-2 mt-6">
                    <button
                      onClick={handleSave}
                      className="px-3 sm:px-4 py-1.5 sm:py-2 bg-blue-500 text-white rounded-md text-sm sm:text-base hover:bg-blue-600 transition-colors"
                    >
                      Save
                    </button>
                    <button
                      onClick={() => setIsSliderOpen(false)}
                      className="px-3 sm:px-4 py-1.5 sm:py-2 bg-red-500 text-white rounded-md text-sm sm:text-base hover:bg-red-600 transition-colors"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {isDeleteModalVisible && (
            <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-75 flex items-center justify-center p-4">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-4">
                <h2 className="text-lg font-medium mb-4">Confirm Delete</h2>
                <p className="text-sm sm:text-base">
                  Are you sure you want to delete this service?
                </p>
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    onClick={() => setIsDeleteModalVisible(false)}
                    className="px-4 py-2 bg-gray-500 text-white rounded-md text-sm sm:text-base"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="px-4 py-2 bg-red-500 text-white rounded-md text-sm sm:text-base"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
     
    </div>
  );
};

export default Service;
